import { computed, ref } from 'vue';
import { Product } from '@/entities/chargebee/product/model';
import { useTask } from '@/ui/concerns';
import { list as listProducts } from '@/services/api/resources/chargebee/product/actions';
import { ProductInterval, ProductSlug } from '@/entities/chargebee/product/constants';
import addYears from 'date-fns/addYears';
import addMonths from 'date-fns/addMonths';

export const numberSeats = ref<number>(1);
export const country = ref('');
export const currency = ref('eur');
export const planType = ref<ProductInterval>(ProductInterval.Year);
export const products = ref<Product[]>([]);
export const getList = useTask(
  () => listProducts(),
  listResponse => {
    products.value = listResponse.data;
  },
);

export const professionalPlans = computed(
  () => products.value.find(product => product.id.includes(ProductSlug.Professional)),
);
export const freePlans = computed(
  () => products.value.find(product => product.id.includes(ProductSlug.Free)),
);

const freePlansForCurrency = computed(() => freePlans.value?.prices.filter(p => p.currencyCode.toLowerCase() === currency.value.toLowerCase()));
export const freePlan = computed(() => freePlansForCurrency.value?.find(p => p.period === ProductInterval.Month));
const professionalPlansForCurrency = computed(() => professionalPlans.value?.prices.filter(p => p.currencyCode.toLowerCase() === currency.value.toLowerCase()));
export const professionalPlan = computed(() => professionalPlansForCurrency.value?.find(p => p.period === planType.value));
export const yearlyPrice = computed(
  () => {
    const product = professionalPlansForCurrency.value?.find(p => p.period === ProductInterval.Year);

    return product?.amount;
  },
);
export const monthlyPrice = computed(
  () => {
    const product = professionalPlansForCurrency.value?.find(p => p.period === ProductInterval.Month);

    return product?.amount;
  },
);
export const finalChargePerUser = computed(() => {
  const unitAmount = professionalPlan.value?.amount;

  if (professionalPlan.value?.period.toLowerCase() === ProductInterval.Year) {
    return (unitAmount as unknown as number / 12).toFixed(2);
  }

  return unitAmount;
});

export const pricePerUser = computed(() => professionalPlan.value?.amount);

export const nextBillingCycle = computed(
  () => planType.value === ProductInterval.Year ? addYears(new Date(), 1) : addMonths(new Date(), 1),
);

export const finalCharge = computed(() => Number(pricePerUser.value) * numberSeats.value);
